export default {
  cms: {
    dev: {
      web: {
        AboutUs: '关于我们',
        ContactUs: '联系我们',
        DeliveryMode: '送货方式',
        FrequentlyQuestions: '常见问题解决',
        LegalDeclarations: '法律声明',
        PrivacyClauses: '隐私条款',
        TermsConditions: '条款与条项',
        JoinUs: '加入我们',
        Title: '标题',
        Category: '类别',
        SimpleDscription: '简要描叙',
        ProductCode: '产品编号',
        CategoryName: '类别名称',
        ProductName: '产品名称',
        PicUrl: '图片',
        JobName: '岗位名称',
        WorkingPlace: '上班地点',
        JobDescription: '岗位描叙',
        TipsTheme: '提示主题',
        Tips: '提示内容',
        Status: '状态',
        // 展厅
        Introduce: '描述',
        PicUpload: '上传图片',
        RoomName: '展厅名称',
        Address: '地址',
        Mobile: '电话',
        Fax: '传真',
        ManagerName: '经理',
        ManagerTel: '经理电话',
        SalesMan: '业务员',
        SalesmanName: '姓名',
        SalesmanTel: '电话',
        RoomTitleCannotBeEmpty: '展厅标题不能为空',
        IntroduceCannotBeEmpty: '描述不能为空',
        PicCannotBeEmpty: '图片不能为空',
        RoomNameCannotBeEmpty: '展厅名称不能为空',
        TelphoneCannotBeEmpty: '电话不能为空',
        AddressCannotBeEmpty: '地址不能为空',
        ManagerNameCannotBeEmpty: '经理不能为空',
        ManagerTelCannotBeEmpty: '经理电话不能为空'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/cms/web.js